module.exports = __webpack_public_path__ + "static/media/Ch2-light.22338d44.jpg";